import React from 'react';

import { BaseTheme, ThemeType } from '../types';

import {
  DefaultFooterLogo,
  DefaultHeaderLogo,
  DefaultRightBackgroundImage,
} from './icons/default';

const baseTheme: BaseTheme = {
  backgroundColor: '#008994',
  textColor: '#FFFFFF',
  textLinkColor: 'base',
};

export const DeadlyDigitsThemes: Array<ThemeType> = [
  {
    title: 'Deadly Digits',
    publicSubFolder: 'deadlydigits',
    tenant: 'DEADLYDIGITS',
    product: 'default',
    baseTheme: baseTheme,
    productTheme: {
      headerLogo: <DefaultHeaderLogo />,
      footerLogo: <DefaultFooterLogo />,
      rightBackgroundImage: <DefaultRightBackgroundImage />,
    },
  },
];
